import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { CustomersModule } from '@customers/customers.module';
import { environment } from '@environments/environment';
// import 'hammerjs';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(CustomersModule)
  .catch(err => console.log(err));